export default __webpack_public_path__ + "static/media/icon-resolve-ticket.a6c474a2.svg";